import styled from "styled-components";
import { BASIC_ORANGE } from "../../../constants/colors";
import { AppCouponFooter } from "../../organisms/AppCouponFooter";
import { AppCouponForm } from "../../organisms/form/AppCouponForm";
import { useAppCoupon } from "./hook";

export const AppCoupon: React.FC = () => {
  const { handleUseAppCoupon, navigateToAppStore } = useAppCoupon();

  return (
    <Container>
      <Title>
        ジョイフル公式アプリを
        <br />
        お持ちの方
      </Title>

      <AppCouponImage
        src={require("../../../assets/app_coupon/app-linkage.png")}
        height={150}
      />

      <Description>
        アプリをお持ちの方は、
        <br />
        利用規約に同意いただく事で、
        <br />
        アプリクーポンを使うことができます。
      </Description>

      <Disclaimer>
        ※アプリクーポンのご利用は、ジョイフルアプリ
        <br />
        バージョン6.1.0以上に対応しています。
      </Disclaimer>

      <AppCouponForm handleSubmit={handleUseAppCoupon} />

      <AppCouponFooter onDownloadApp={navigateToAppStore} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  margin: 16px 0 5px;
`;

const AppCouponImage = styled.img`
  height: 150px;
  margin: 20px 0;
`;

const Description = styled.div`
  font-size: 14px;
  text-align: center;
`;

const Disclaimer = styled.div`
  margin-top: 10px;
  font-size: 12px;
  font-weight: 600;
  color: ${BASIC_ORANGE};
  text-align: center;
`;
